import './ModalNewRequest.scss'
import React, { useEffect, useState } from 'react'
import { Col, Row, Icon, Steps, message, notification } from 'antd'
import { useTranslation } from 'react-i18next'
import {Step1Page, Step2FilePage, Step2BdPage, Step3Page} from './components'
import { sendBdRequestPromise } from '../../../Register/promises'
import { sendNewRequestFilePromise } from '../../../Register/promises'

const ModalNewRequest = ({closeModalRequest, currentUser}) => {
    const { t } = useTranslation()
    const [currentStep, setCurrentStep] = useState(0);
    const [selectedOption, setSelectedOption] = useState();
    const [formFile, setFormFile] = useState(null);
    const [formBd, setFormBd] = useState(null);


    const sendFormFile = (declType, category, formFile, onComplete) => {
        const formData = new FormData()
        formData.append('file', formFile)
        formData.append("category", category)
        formData.append("type", declType)


        sendNewRequestFilePromise(formData)
            .then(results => {
            if(results.status === 'OK') {
                message.success(t('messages.aml.cdi.modalNewRequest.sentSuccess'))
                closeModalRequest();
            }else {
                notification.error({
                    message: 'Error',
                    description: results.message
                })
                if (onComplete) onComplete();
            }
        })
        .catch(() => {
            if (onComplete) onComplete();
        })
    }

    const sendFormS3 = (recipients, declType) => {

        if (declType) {
            sendBdRequestPromise({...formBd, recipients}, declType).then(results => {
                    if(results === 'Solicitud eviada correctamente' && recipients.length > 0) {
                        message.success(t('messages.aml.cdi.modalNewRequest.sentSuccess'))
                        closeModalRequest();
                    }else {
                        notification.error({
                        message: 'Error',
                        description: recipients.length === 0 ? t('messages.aml.cdi.modalNewRequest.errorNoRecipients') : results.message
                        })
                    }
                }
            )
        }else{
            message.error(t('messages.aml.cdi.modalNewRequest.errorNoDeclType'))
        }
    }

    const next2File = (file) => {
        setFormFile(file);
        next();
    }

    const next2Bd = (bd) => {
        setFormBd(bd);
        next();
    }

    const next = () => {
        const current = currentStep + 1;
        setCurrentStep(current);
    }

    const prev = () => {
        const current = currentStep - 1;
        setCurrentStep(current);
    }

    const fileOrBd = (option) => {
        setSelectedOption(option);
        next();
    }



    return(
        <div className="modal-newrequest-onb">
            <div className="topBar-nr-onb">
                    <Row>
                        <Col span={6}>
                            <div className="topBar-nr-onb-title">
                                { t('messages.aml.cdi.modalNewRequest.title') }
                            </div>
                        </Col>
                        <Col span={1} push={17}>
                            <div className="button-close-ob">
                                <a href="#" onClick={closeModalRequest}><Icon type="close" style={{color:'black', fontSize:'20px'}} /></a>
                            </div>
                        </Col>

                    </Row>
            </div>
            <div className="nr-onb-content-steps">
                <div className="nr-onb-steps">
                    <hr />
                            <Steps current={currentStep}>

                                <Steps.Step title={ t('messages.aml.cdi.modalNewRequest.step1Title') } />

                                {currentStep === 1 && selectedOption === "file" &&
                                    <Steps.Step title={ t('messages.aml.cdi.modalNewRequest.step2FileTitle') } />
                                }
                                {currentStep > 0 && selectedOption === "bd" &&
                                    <Steps.Step title={ t('messages.aml.cdi.modalNewRequest.step2BdTitle') } />
                                }
                                {currentStep > 0 && selectedOption === "bd" &&
                                    <Steps.Step title={ t('messages.aml.cdi.modalNewRequest.step3Title') } />
                                }
                            </Steps>
                    <hr />
                </div>
                <div className="steps-content">
                    {currentStep === 0 &&
                        <Step1Page fileOrBd={fileOrBd}/>
                    }
                    { currentStep === 1 && selectedOption === "file" &&
                        <Step2FilePage next={next2File} sendFormFile={sendFormFile} prev={prev} currentUser={currentUser}/>
                    }
                    { currentStep === 1 && selectedOption === "bd" &&
                        <Step2BdPage next2Bd={next2Bd} prev={prev} formBd={formBd} currentUser = {currentUser}/>
                    }
                    {currentStep === 2 &&
                        <Step3Page prev={prev} formBd={formBd} sendFormS3={sendFormS3} currentUser = {currentUser}/>
                    }
                </div>
            </div>
        </div>
    );
}

export default ModalNewRequest
